var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "photoclaim-gallery" }, [
    _vm.photosTaken
      ? _c("div", { staticClass: "photoclaim-gallery__damages" }, [
          _c("div", { staticClass: "damage__space" }, [
            _c(
              "div",
              { staticClass: "damage__photos" },
              _vm._l(_vm.spacePhotos, function (photo) {
                return _c("figure", { staticClass: "damage-img" }, [
                  _c("img", { attrs: { src: photo.thumbnailURL } }),
                ])
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "damage-parts__container" },
            _vm._l(_vm.damagedParts, function (damagedPart) {
              return _c("div", { staticClass: "damage__parts" }, [
                _c("div", { staticClass: "damage__title" }, [
                  _vm._v(_vm._s(damagedPart.literal)),
                ]),
                damagedPart.partDamages.length > 0
                  ? _c(
                      "div",
                      { staticClass: "damage__photos" },
                      _vm._l(
                        _vm.firstPhotos(damagedPart.partDamages),
                        function (photo) {
                          return _c("figure", { staticClass: "damage-img" }, [
                            _c("img", { attrs: { src: photo.thumbnailURL } }),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                damagedPart.partDamages.length > 0
                  ? _c("p", { staticClass: "damages-detected" }, [
                      _vm._v("Nous avons détecté les dommages suivants:"),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "damages-container" },
                  _vm._l(damagedPart.partDamages, function (damage, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "damage-ia-item",
                        class: {
                          "damage-ia-item--confirmed": damage.damageConfirmed,
                        },
                      },
                      [
                        _c("div", { staticClass: "damage-header" }, [
                          _c("p", { staticClass: "damage-header__title" }, [
                            _vm._v(_vm._s(damage.literal)),
                          ]),
                          !damage.damageConfirmed
                            ? _c(
                                "div",
                                { staticClass: "damage-header__option" },
                                [
                                  _c("svgicon", {
                                    attrs: {
                                      name: "ico-pencil-create",
                                      color: "#566473",
                                      height: "20",
                                      width: "auto",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleButtonEdit(
                                          damagedPart,
                                          index
                                        )
                                      },
                                    },
                                  }),
                                  _c("svgicon", {
                                    attrs: {
                                      name: "ico-trash",
                                      color: "#566473",
                                      height: "20",
                                      width: "auto",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleButtonDelete(
                                          damagedPart,
                                          index
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          damage.damageConfirmed
                            ? _c(
                                "div",
                                { staticClass: "damage-header__option" },
                                [
                                  _c("svgicon", {
                                    attrs: {
                                      name: "ico-confirmed",
                                      color: "#005BA5",
                                      height: "22",
                                      width: "auto",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        !damage.damageConfirmed
                          ? _c("div", { staticClass: "damage-body" }, [
                              _vm._v(_vm._s(damage.description)),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm.photosTaken && !damagedPart.damagesSended
                  ? _c("div", { staticClass: "damages-btn-container" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function ($event) {
                              return _vm.handleButtonAdd(damagedPart)
                            },
                          },
                        },
                        [
                          _c("svgicon", {
                            attrs: {
                              name: "plus",
                              color: "#566473",
                              height: "16",
                              width: "auto",
                            },
                          }),
                          _c("p", { staticClass: "text-medium" }, [
                            _vm._v("Ajouter des dégâts"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--confirm",
                          attrs: {
                            disabled: damagedPart.partDamages.length === 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleButtonConfirm(damagedPart)
                            },
                          },
                        },
                        [
                          _c("p", { staticClass: "text-medium" }, [
                            _vm._v("Confirmez les dommages"),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            }),
            0
          ),
        ])
      : _vm._e(),
    !_vm.photosTaken
      ? _c(
          "div",
          { staticClass: "container-btn-add-element-photoclaim" },
          [
            _vm._l(_vm.damagedParts, function (damagedPart) {
              return _c("div", { staticClass: "btn__parts" }, [
                _c("div", { staticClass: "btn__parts-title" }, [
                  _vm._v(_vm._s(damagedPart.literal)),
                ]),
              ])
            }),
            _c(
              "button",
              { staticClass: "btn", on: { click: _vm.handleOnShowModal } },
              [
                _c("svgicon", {
                  attrs: {
                    name: "ico-camera",
                    color: "#005BA5",
                    height: "24",
                    width: "auto",
                  },
                }),
                _c("p", { staticClass: "text-medium" }, [
                  _vm._v(
                    _vm._s(_vm.$t("multidamageList.btnAddDamagePhotoclaim"))
                  ),
                ]),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }